import axios from 'axios';

const client = axios.create({
    baseURL: window.__RUNTIME_CONFIG__.REACT_APP_DEM,
    responseType: 'json'
});

export default client;
